<div class="category-freetext">
  <mat-list
    cdkDropList
    [cdkDropListData]="userDefinedFields"
    [cdkDropListEnterPredicate]="preventDrop"
    id="toolbox-freetext"
  >
    <!-- Button to add fields to the list-->
    <mat-list-item>
      <button rotec-button-active (click)="addField()" icon="plus" class="addButton">
        {{ 'btnAddFreeField' | translate }}
      </button>
    </mat-list-item>
    <!-- The list of free fields -->
    @for (userDefinedField of userDefinedFields; track userDefinedField) {
      <mat-list-item cdkDrag [cdkDragData]="userDefinedField" class="draggable-item">
        <rotec-icon svgIcon="draggablelist" class="icon"></rotec-icon>
        <rc-template-toolbox-item-freetext
          [item]="userDefinedField"
          (onDeleteItem)="removeField($event)"
          class="item-freetext"
        >
        </rc-template-toolbox-item-freetext>
        <!-- This item is only activated while dragging! -->
        <!-- NOTE:
        If you see an error below, this is due to the fact that the bisect pipe above is generic and 'ng' cannot resolve the actual type.
        With Ivy, this should be fixed.
        -->
        <span *cdkDragPreview>{{ userDefinedField.value | slice: 0 : 64 }}</span>
        <span *cdkDragPlaceholder>{{ userDefinedField.value | slice: 0 : 64 }}</span>
      </mat-list-item>
    }
  </mat-list>
</div>
